import { ColumnHeaderUi, PagingUi } from '@/components/TableData/TableDataUi';

export type SellerItemUi = {
  id: string;
  sellerName: string;
  accountName: string;
  email: string;
  phone: string;
};

export type SellersUi = {
  columnHeaders: ColumnHeaderUi[];
  items: SellerItemUi[];
  paging?: PagingUi;
  searchQuery: string;
  isSearching?: boolean;
  isLoading?: boolean;
};

const tableHeaders = [
  { label: 'Nombre de Vendedor' },
  { label: 'Nombre de Tienda' },
  { label: 'Email' },
  { label: 'Teléfono' },
];

export const initialState: SellersUi = {
  columnHeaders: tableHeaders,
  items: [],
  searchQuery: '',
};
